import gql from 'graphql-tag';
import { querySelector } from '../../../utils';
import { GetAllBonusEligibleTickets } from './allTicketsForMonthApi';

const SetTicketBonusMutation = gql`
  mutation SetTicketBonus($input: UserTicketBonusSetInput!) {
   user_ticket_bonus_set(input: $input) {
      id
    }
  }
`;


export const setTicketBonusApi = async (client, userTicketBonusArray, bonusMonth, districtId, showProcessed) => {
  const variables = {
    input: {
      user_ticket_bonuses: userTicketBonusArray,
    },
  };


  const options = {
    mutation: SetTicketBonusMutation,
    variables,
    refetchQueries: [
      { query: GetAllBonusEligibleTickets, variables: { bonusMonth, districtId, showProcessed } },
    ],
  };


  const cachedQueryResults = client.readQuery({
    query: GetAllBonusEligibleTickets,
    variables: { bonusMonth, districtId, showProcessed },
  });

  const oldCollection = querySelector(cachedQueryResults, '$.all_bonus_eligible_tickets.edges[*].node', []);

  const result = await client.mutate(options);
  return {
    oldCollection,
    result,
  };
};
